'use client';
import { getHomeTeamName, getTeamName } from '@/utils/odds-utils';
import { OddsModel, MatchModelBase, CricketMatchModel } from '@nf/types/odds';
import { useTranslations } from 'next-intl';
import { TopbarTeamDot } from './top-bar-team-dot';

export const MatchTeamName = ({ oddsData, match }: { oddsData: OddsModel | null; match: MatchModelBase; }) => {
	const { TeamId1, TeamId2, Neu } = match;
	const t = useTranslations('General');
	const homeTeamName = getHomeTeamName(TeamId1, Neu, t('Neutral_Team'), oddsData?.teamNameMap);
	const awayTeamName = getTeamName(TeamId2, oddsData?.teamNameMap);

	return (
		<div className="select-match-item__team">
			<div className="team-name">
				{match.GameID === 44 && <TopbarTeamDot variant="red" />}
				{
					match.GameID === 50 ? (
						<TopbarTeamDot
							variant="serve"
							isActive={(match as CricketMatchModel).ls?.trn === '1'}
						/>
					) : null
				}
				{homeTeamName}
			</div>

			<div className="team-name">
				{match.GameID === 44 && <TopbarTeamDot variant="blue" />}
				{
					match.GameID === 50 ? (
						<TopbarTeamDot
							variant="serve"
							isActive={(match as CricketMatchModel).ls?.trn === '2'}
						/>
					) : null
				}
				{awayTeamName}
			</div>
		</div>
	);
};
